export function initInvestorNav() {
    const navItems = document.querySelectorAll('.investor-nav-item');
    
    navItems.forEach(item => {
        const toggle = item.querySelector('.investor-nav-toggle');
        const content = item.querySelector('.investor-nav-content');
        const icon = item.querySelector('.investor-nav-icon svg');
        
        if (!toggle || !content) return;
        
        // Get initial state
        const isExpanded = toggle.getAttribute('data-expanded') === 'true';
        
        // Set initial state
        if (isExpanded) {
            content.classList.remove('collapsed');
            content.classList.add('expanded');
            content.style.maxHeight = 'none';
            if (icon) {
                icon.style.transform = 'rotate(45deg)';
            }
        } else {
            content.classList.add('collapsed');
            content.classList.remove('expanded');
            content.style.maxHeight = '0';
        }
        
        toggle.addEventListener('click', (e) => {
            // Don't prevent default if clicking on the link itself
            if (e.target.tagName === 'A') {
                return;
            }
            
            e.preventDefault();
            
            const currentlyExpanded = toggle.getAttribute('data-expanded') === 'true';
            const newState = !currentlyExpanded;
            
            // Update state
            toggle.setAttribute('data-expanded', newState);
            
            // Toggle content visibility
            if (newState) {
                // Expand
                content.classList.remove('collapsed');
                content.classList.add('expanded');
                
                // Get the full height needed
                content.style.maxHeight = 'none';
                const fullHeight = content.scrollHeight;
                content.style.maxHeight = '0';
                
                // Trigger animation
                requestAnimationFrame(() => {
                    content.style.transition = 'max-height 0.3s ease-out';
                    content.style.maxHeight = fullHeight + 'px';
                    
                    // After animation, set to none for flexibility
                    setTimeout(() => {
                        if (toggle.getAttribute('data-expanded') === 'true') {
                            content.style.maxHeight = 'none';
                        }
                    }, 300);
                });
                
                // Rotate icon
                if (icon) {
                    icon.style.transform = 'rotate(45deg)';
                }
            } else {
                // Collapse
                // Get current height
                const currentHeight = content.scrollHeight;
                content.style.maxHeight = currentHeight + 'px';
                
                // Trigger animation
                requestAnimationFrame(() => {
                    content.style.transition = 'max-height 0.3s ease-out';
                    content.style.maxHeight = '0';
                });
                
                // Update classes after animation
                setTimeout(() => {
                    content.classList.remove('expanded');
                    content.classList.add('collapsed');
                }, 300);
                
                // Rotate icon back
                if (icon) {
                    icon.style.transform = 'rotate(0deg)';
                }
            }
        });
    });
}
